<template>
  <!-- {
        'std-active-left': !loadingStrategy,
      }, -->
  <LayoutStudy
    class="rabbuildr"
    :layout="[
      mobile && 'small_screen_layout',
      mobile && !isFinished ? 'laytsttd_main-hidden' : swLayoutStudy,
    ]"
    :spacing="swSpacingStudy"
    mainWidth="strategy_layout"
    :class="[
      lockMode,
      `rabbuildr_${builderMode}`,
      {
        'std-active': messages || !rab_solution_paint.length || !canInitialize,
      },
      !rab_result && lockMode !== 'disabled'
        ? `rabbuildr_lock-mode rabbuildr_lock-mode_${lockMode} rabbuildr_lock-paint_${paintMode} `
        : '',
      !!rab_result ? 'rabbuildr_finished' : '',
    ]"
    :style="rab_svgCursor"
    :asideHidden="!!rab_result"
    :hspotsHidden="hspotsHidden"
  >
    <template #hspots>
      <slot name="start" />
      <slot name="hSpots" />
    </template>
    <template #aside>
      <!-- :hasConfirm="hasConfirm" -->
      <RangeBuilderAside
        :style="`transition:1s; opacity: ${onStart ? 0.2 : 1}`"
        rangeTab="strategy"
        :namespace="namespace"
        :applyFilterActionName="builderMode === 'mode_nodelock' ? null : 'sol_data_applyFilter'"
        :onStart="onStart"
        :toolTabs="toolTabs"
        :builderMode="builderMode"
        :lockedActions="nodelockLockedActions"
        :rab_tableGroups="rab_tableGroups"
        :filterCategories="filterCategories"
        :heroGroup="canInitialize ? heroGroup : null"
        :heroGroupId="heroGroupId"
        :viewProps="viewProps"
        :filterCombos="filterCombos"
        :tableMouseover="tableMouseover"
        :hSpot="hSpot"
        :street="solStreet"
        :solution_picked="solution_picked"
        :rab_solution_picked="rab_solution_picked"
        :hero="solStatic.hero"
        :opponent="solStatic.opponent"
        :rab_solution_paint="rab_solution_paint"
        :catDraws="rab_catDraws"
        :catHands="rab_catHands"
        :catEqBuckets="rab_catEqBuckets"
        :catEqBucketsAdvanced="rab_catEqBucketsAdvanced"
        :showBetsIn="showBetsIn"
        :bettingInfo="{ showEvIn, pot: hSpot.pot }"
        :useHex="useHex"
        :showFlopContent="showFlopContent"
        :isPreflop="isPreflop"
        :mobile="mobile"
        :grouping="grouping"
        :hasPremiumGameformat="hasPremiumGameformat"
        :gameformat="gameformat"
        :rangeTableGroupsIds="all_combos"
        :btnMode="btnMode"
        :loadingStrategy="loadingStrategy"
        :paintMode="paintMode"
        :lockMode="lockMode"
        :solElite="solElite"
        :nodelockFreqMode="nodelockFreqMode"
        :loadingConfirm="loadingConfirm"
        style="z-index: 3"
        @hands:mousedown="handleMousedown"
        @hands:touchmove="handleHandsTouchmove"
        @update:nodelockfreqmode="item => (nodelockFreqMode = item)"
        @update:lockedactions="item => (nodelockLockedActions = item)"
        @update:actionssliders="
          ({ actions, keepLocks }) => $emit('update:actionssliders', { actions, keepLocks })
        "
        @update:actions="handleActionUpdate"
        @combo:mousedown="handleComboMousedown"
        @combo:mouseenter="handleComboMouseenter"
        @hand:mouseenter="handleHandMouseenter"
        @hand:mousedown="handleHandMousedown"
        @click:category="handleCategoryClick"
        @click:confirm="handleConfirmClick"
        @click:btnmode="handleBtnModeClick"
        @click:paintmode="handlePaintModeClick"
        @lock:reset="resetLocks(false)"
        @click:lockall="resetLocks(true)"
        @click:unlockall="resetLocks(false)"
        @click:initialize="initialize({ lockValue: false })"
      >
        <!-- <template :slot="!mobile && $store.getters.screen_landscape ? 'before' : 'none'">
          <div
            class="d-flex gw_box"
            style="--box-padding: 0 0.25rem; height: 2.5rem"
          >
            <StudyTableTile
              :hSpot="hSpot"
              :street="solStreet"
              :gameformat="gameformat"
              :mobile="mobile"
              :solElite="solElite"
            />
          </div>
        </template> -->
        <template
          v-if="mobile && !$store.getters.screen_landscape"
          #before
        >
          <div
            class="d-flex gw_box"
            style="--box-padding: 0 0.25rem; height: 2.5rem"
          >
            <StudyTableTile
              v-if="filterCombos.status === 'inactive'"
              :hSpot="hSpot"
              :street="solStreet"
              :gameformat="gameformat"
              :mobile="mobile"
              :solElite="solElite"
            />
            <StudyFiltersPills
              v-else
              style="--clr-pills-back: var(--clr-black-1)"
              :namespace="namespace"
              :hasFilterIntersection="true"
              :alwaysVisible="true"
              class="my-auto ml-auto"
              :street="solStreet"
              soltab="strategy"
              :filterCombos="filterCombos"
              :showBetsIn="showBetsIn"
            />
          </div>
        </template>
        <template
          v-if="mobile"
          #before_confirm
        >
          <RangeBuilderControls
            style="
              z-index: 4;
              position: relative;
              --max-height: unset;
              --icon-font-size: 1.5rem;
              --text-font-size: 1rem;
            "
            :backDisabled="backDisabled"
            :forwardDisabled="forwardDisabled"
            @click:go="go"
            @click:clear="initialize"
          />
        </template>
        <template
          v-if="mobile && !isFinished"
          #strategy
        >
          <RangeBuilderMain
            :style="`transition:1s;opacity: ${onStart ? 0.2 : 1}`"
            style="z-index: 1; position: relative"
            rangeTab="strategy"
            :namespace="namespace"
            :rab_solution_picked="rab_solution_picked"
            :tableGroups="solDynamic.tableGroups"
            :rab_tableGroups="rab_tableGroups"
            :solution="solDynamic.solution"
            :hSpot="hSpot"
            :viewProps="viewProps"
            :heroGroup="heroGroup"
            :heroGroupId="heroGroupId"
            :heroGroupsIds="heroGroupsIds"
            :tableMouseover="tableMouseover"
            :isFinished="isFinished"
            :loadingStrategy="loadingStrategy"
            :rab_result="rab_result"
            :heroLeft="true"
            :grouping="grouping"
            :useHex="useHex"
            :showBetsIn="showBetsIn"
            :mobile="mobile"
            :randomBoard="randomBoard"
            @table:mousedown="handleMousedown"
            @table:touchmove="handleTableTouchmove"
            @combo:click="handleCombosClick"
            @combo:mouseenter="handleCombosMouseenter"
            @combo:mousedown="handleCombosMousedown"
            @click:repeat="initialize"
            @click:new_board="$emit('click:new_board')"
          />
        </template>
      </RangeBuilderAside>
    </template>
    <template #main>
      <div
        v-if="mobile && !$store.getters.screen_landscape"
        class="d-flex gw_box"
        style="--box-padding: 0 0.25rem; height: 2.5rem; margin: 0 0 0.25rem 0"
      >
        <StudyTableTile
          :hSpot="hSpot"
          :street="solStreet"
          :gameformat="gameformat"
          :mobile="mobile"
          :solElite="solElite"
        />
      </div>
      <div
        v-if="!mobile"
        class="d-flex"
        style="min-width: 0; gap: 0rem"
        :class="{
          'opacity_0 no-events': !rab_solution_paint.length || !canInitialize,
        }"
      >
        <div
          class="role_spacer"
          style="height: 1.75rem"
        ></div>
        <RangeBuilderControls
          v-if="!mobile && !rab_result"
          style="z-index: 4; position: relative"
          :backDisabled="!snapshots_to[0]"
          :forwardDisabled="!snapshots_from[0]"
          @click:go="go"
          @click:clear="initialize"
        />

        <StudyFiltersPills
          v-if="!mobile"
          class="ml-auto mr-1"
          :namespace="namespace"
          :hasFilterIntersection="true"
          :alwaysVisible="true"
          :street="street"
          :showBetsIn="showBetsIn"
          :filterCombos="filterCombos"
          soltab="strategy"
        />
        <StudyTableTileMini
          style="height: 1.625rem; margin: 0 1px 0 0"
          :hSpot="hSpot"
        >
        </StudyTableTileMini>
        <div
          v-if="!mobile"
          class="d-flex"
          style="gap: 1px"
        >
          <div
            v-if="hasRangePopup"
            class="gw_box f-center"
            style="
              height: 1.625rem;
              gap: 2px;
              padding: 0 0.375rem;
              --clr-box-back: var(--clr-black-1);
              border-radius: 6px;
            "
          >
            <div
              class="icon_btn mdi mdi-table csst"
              style="padding: 0.25rem; margin: -0.25rem"
              @click="openRangesDialog"
              @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
            >
              <div
                class="csst_content text-nowrap"
                style="position: fixed"
              >
                {{ $t('tooltips.show_ranges') }}
              </div>
            </div>
          </div>
          <StudyControlsRanges
            :hasEvConverterSwitch="false"
            style="z-index: 2"
          />
          <StudyControlsMain
            :hasLayoutSwitch="hasLayoutSwitch"
            :hasFullscreen="false"
            style="z-index: 2"
          />
        </div>
      </div>
      <RangeBuilderMain
        :style="`transition:1s;opacity: ${onStart ? 0.2 : 1}`"
        style="z-index: 1; position: relative"
        rangeTab="strategy"
        :namespace="namespace"
        :rab_solution_picked="rab_solution_picked"
        :tableGroups="solDynamic.tableGroups"
        :rab_tableGroups="rab_tableGroups"
        :solution="solDynamic.solution"
        :hSpot="hSpot"
        :viewProps="viewProps"
        :heroGroup="heroGroup"
        :heroGroupId="heroGroupId"
        :heroGroupsIds="heroGroupsIds"
        :tableMouseover="tableMouseover"
        :isFinished="isFinished"
        :loadingStrategy="loadingStrategy"
        :rab_result="rab_result"
        :heroLeft="true"
        :grouping="grouping"
        :useHex="useHex"
        :showBetsIn="showBetsIn"
        :showFlopContent="showFlopContent"
        :mobile="mobile"
        :randomBoard="randomBoard"
        @table:mousedown="handleMousedown"
        @table:touchmove="handleTableTouchmove"
        @combo:click="handleCombosClick"
        @combo:mouseenter="handleCombosMouseenter"
        @combo:mousedown="handleCombosMousedown"
        @click:repeat="initialize"
        @click:new_board="$emit('click:new_board')"
      />
    </template>
    <template #after>
      <slot name="after"></slot>
    </template>
  </LayoutStudy>
</template>

<script>
import RangeBuilderControls from '@/components/Study/RangeBuilderControls'
import StudyControlsMain from '@/components/Study/StudyControlsMain'
import StudyControlsRanges from '@/components/Study/StudyControlsRanges'
import StudyFiltersPills from '@/components/Study/StudyFiltersPills'
import { SNK } from '@/helpers/helpers'
import {
  getSvgCursor,
  getScoreGroup,
  getScoreGroups,
  getEqualSolution,
  getRelativeSimilarity,
} from '@/helpers/rangeBuilder'
import { getCombosSolution, rangeTableGroups } from '@/helpers/solution'
import { getGroupedActions } from '@/helpers/grouping'
import { getActionStyles } from '@/store/gamestate/gamestate'

import LayoutStudy from '@/layouts/LayoutStudy'
import RangeBuilderMain from '@/components/Practice/RangeBuilder/RangeBuilderMain'
import RangeBuilderAside from '@/components/Practice/RangeBuilder/RangeBuilderAside'
import StudyTableTile from '@/components/Study/StudyTableTile'
import StudyTableTileMini from '@/components/Study/StudyTableTileMini'

import float_mix from '@/mixins/float_mix'

export default {
  name: 'RageBuilderV2',
  components: {
    LayoutStudy,
    RangeBuilderMain,
    RangeBuilderAside,
    StudyTableTile,
    StudyTableTileMini,

    RangeBuilderControls,
    StudyControlsMain,
    StudyControlsRanges,
    StudyFiltersPills,
  },
  mixins: [float_mix],
  props: {
    namespace: { required: true },
    // hasConfirm: { type: Boolean,  default: true },
    defaultToCheckFold: { type: Boolean, default: true },
    hasLayoutSwitch: { type: Boolean, default: true },
    hasRangePopup: { type: Boolean, default: true },
    toolTabs: { default: () => ['tools', 'hint', 'poker_table'] },
    // toolBtns: { default: () => ['paint', 'lock'] },
    builderMode: { default: 'mode_builder' },
    // applyFilterActionName: { default: () => 'sol_data_applyFilter' },
    loadingStrategy: Boolean,
    loadingConfirm: Boolean,
    onStart: Boolean,
    hspotsHidden: Boolean,
    useHex: Boolean,
    grouping: String,
    showBetsIn: String,
    showEvIn: String,
    mobile: Boolean,
    gameformat: Object,
    solElite: Object,
    hasPremiumGameformat: Boolean,
    street: String,
    randomBoard: Boolean,
    messages: Array,
    hotkeysPressed: Array,
    solDynamic: Object,
    solStatic: Object,
    canInitialize: Boolean,
    filterCombos: Object,

    swLayoutStudy: String,
    swSpacingStudy: String,

    solution_picked: Array,
    filterCategories: Array,
    heroGroup: Object,
    heroGroupId: String,
    heroGroupsIds: Array,
    viewProps: Object,
    tableMouseover: Boolean,
    hSpot: Object,
    solStreet: String,
  },
  emits: [
    'update:actionssliders',
    'click:new_board',
    'update:tablegroups',
    'click:confirm',
    'reset',
  ],
  data() {
    this.all_combos = rangeTableGroups()
    this.heroIndex = 0
    return {
      rab_solution_paint: [],
      rab_svgCursor: { '--rab-cursor': 'default' },

      rab_tableGroups: [],
      rab_solution_picked: [],
      rab_catDraws: [],
      rab_catHands: [],
      rab_catEqBuckets: [],
      rab_catEqBucketsAdvanced: [],

      rab_result: null,

      mousedownTimestamp: 0,

      btnMode: this.builderMode === 'mode_builder' ? 'painter' : 'frequency',
      lockMode: 'disabled',
      paintMode: 'paint_custom',

      // nodelockFreqMode: 'keep_locked_hands',
      nodelockFreqMode: 'overwrite_all',
      nodelockLockedActions: [],

      snapshots_from: [],
      snapshots_to: [],
    }
  },
  created() {
    this.resetState()
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    openRangesDialog() {
      this.$store.dispatch('router_set_dialogs', `study-compare-rangebuilder-dialog`)
    },
    removeEventListeners() {
      window.removeEventListener('mouseup', this.handleMouseup)
      window.removeEventListener('touchend', this.handleMouseup)
    },
    handleMouseup() {
      this.mousedownTimestamp = 0
      this.lockMode = this.lockMode === 'disabled' ? 'disabled' : 'action-unset'

      this.removeEventListeners()

      this.getRabSolutionPicked()
      this.getRabCategoriesSolution()
      this.emitUpdate()
    },
    emitUpdate() {
      this.$emit('update:tablegroups', this.rab_tableGroups)
    },
    handleCategoryClick(category) {
      // this.handleMousedown()
      const l_combos = this.rab_tableGroups.reduce((a, b) => [...a, ...b.combos], [])
      category.players[this.heroIndex].combos.forEach(ccId => {
        const hand = l_combos.find(cc => cc.id === ccId)
        this.handleHandMousedown({
          // this.handleHandClick({
          combo: hand,
          disabled: !hand.players[this.heroIndex].range,
        })
      })
      this.handleMouseup()
    },
    handleMousedown() {
      this.mousedownTimestamp = Date.now()
      window.addEventListener('mouseup', this.handleMouseup)
      window.addEventListener('touchend', this.handleMouseup)
    },
    handleHandMousedown({ combo, disabled }) {
      this.handleHandMouseenter({ combo, disabled }, 'force')
    },
    handleCombosMousedown({ combos, disabled, trigger }) {
      if (combos.id === this.heroGroupId) return
      this.handleCombosMouseenter({ combos, disabled, closeCombos: true, trigger }, true)
    },
    handleCombosClick({ combos, disabled, trigger }) {
      if (combos.id === this.heroGroupId) return
      this.handleCombosMouseenter(
        { combos, disabled, trigger, closeCombos: true, caller: 'click' },
        true,
      )
    },
    handleCombosMouseenter(
      { combos, combos_hands, disabled, closeCombos, trigger, caller },
      force,
    ) {
      if (disabled) return
      if (trigger === 'title') return
      if (!force && !this.mousedownTimestamp) return

      let lockValue = null
      if (this.lockMode !== 'disabled') {
        if (caller === 'click') {
          if (closeCombos) {
            this.$store.commit(SNK('sol_detail_set', this.namespace), {
              key: 'players_detail',
              value: '',
              player: '0',
              playerProperty: 'group_id',
            })
          }
          return
        }
        if (this.lockMode === 'action-unset') {
          this.lockMode = !(combos_hands || [combos]).every(i => i.is_locked)
            ? 'action-lock'
            : 'action-unlock'
        }
        lockValue = this.lockMode === 'action-lock'
      } else if (
        this.builderMode === 'mode_builder' &&
        (combos_hands || [combos]).some(i => i.is_locked)
      ) {
        const unlockedHands = combos.combos.filter(cc => !cc.is_locked)
        if (!unlockedHands.length) return
        this.handleCombosMouseenter(
          { combos, combos_hands: unlockedHands, disabled: false, closeCombos: true },
          true,
        )
        return
      }

      if (closeCombos) {
        this.$store.commit(SNK('sol_detail_set', this.namespace), {
          key: 'players_detail',
          value: '',
          player: '0',
          playerProperty: 'group_id',
        })
      }

      const from = {
        stra_combos: combos.solution.map(i => i.strategy),
        stra_hands: combos.combos.map(cc => cc.solution.map(i => i.strategy)),
        lock_combos: combos.is_locked,
        locks_hands: combos.combos.map(cc => cc.is_locked),
      }

      const handsIds = (combos_hands || combos.combos).map(i => i.id)
      const paintAllHands = handsIds === combos.combos.length
      let hands = []

      if (lockValue !== null) {
        // task = 'assignlock'
        hands = combos.combos.map(cc => {
          if (!cc.players[this.heroIndex].range) return cc
          if (paintAllHands || handsIds.includes(cc.id)) {
            cc.is_locked = lockValue
            return cc
          }
          return cc
        })
      } else {
        const addLock = this.builderMode === 'mode_nodelock' && this.paintMode === 'paint_lock'
        const removeLock =
          // let paintGtoRemoveLock =
          this.builderMode === 'mode_nodelock' && this.paintMode === 'paint_unlock'

        const paintAndAddLock =
          this.builderMode === 'mode_nodelock' && this.paintMode === 'paint_custom'

        const paint = this.builderMode === 'mode_builder' && this.paintMode === 'paint_custom'
        // console.log({
        //   addLock,
        //   // paintGtoRemoveLock,
        //   removeLock,
        //   paintAndAddLock,
        //   builderMode: this.builderMode,
        //   paintMode: this.paintMode,
        // })

        hands = combos.combos.map(cc => {
          if (!cc.players[this.heroIndex].range) return cc
          if (paintAllHands || handsIds.includes(cc.id)) {
            cc.is_locked = addLock || paintAndAddLock ? true : removeLock ? false : cc.is_locked
            // addLock || paintAndAddLock ? true : paintGtoRemoveLock ? false : cc.is_locked
            // cc.solution = addLock
            //   ? cc.solution
            //   : cc.solution.map((i, idx) => ({
            //       ...i,
            //       strategy: paintGtoRemoveLock
            //         ? cc.default.solution[idx].strategy
            //         : this.rab_solution_paint[idx].strategy,
            //     }))
            cc.solution =
              paint || paintAndAddLock
                ? cc.solution.map((i, idx) => ({
                    ...i,
                    strategy: this.rab_solution_paint[idx].strategy,
                  }))
                : cc.solution
            return cc
          }
          return cc
        })
      }

      const handsInRange = hands.filter(cc => cc.players[this.heroIndex].range)
      const combosSolution = getCombosSolution({
        combos: handsInRange,
        solution: this.rab_solution_paint,
      })
      const to = {
        stra_combos: combosSolution.map(i => i.strategy),
        stra_hands: hands.map(cc => cc.solution.map(i => i.strategy)),
        lock_combos: hands.some(cc =>
          !cc.players[this.heroIndex].default.range ? false : cc.is_locked,
        ),
        locks_hands: hands.map(cc => cc.is_locked),
      }

      if (JSON.stringify(from) === JSON.stringify(to)) return
      const snapshot = {
        timestamp: this.mousedownTimestamp,
        combos_id: combos.id,
        combos_table_index: combos.table_index,
        // task,
        from,
        to,
      }
      this.snapshots_to = [snapshot, ...this.snapshots_to]
      this.applySnapshot({ snapshot, fromTo: 'to' })
    },
    handleTableTouchmove(e) {
      let id = this.getMouseoverId(e)
      if (id?.includes('hero_')) {
        id = id.replace('hero_', '')
        const combos = this.rab_tableGroups.find(gg => gg.id === id)
        if (!combos) return
        this.handleCombosMouseenter(
          { combos, disabled: !combos.players[this.heroIndex].range, closeCombos: true },
          false,
        )
      }
    },
    handleHandsTouchmove(e) {
      let id = this.getMouseoverId(e)
      if (id?.includes('hero_')) {
        id = id.replace('hero_', '')
        const hand = (
          this.rab_tableGroups.find(gg => gg.combos.find(cc => cc.id === id)) || []
        ).combos.find(cc => cc.id === id)
        if (!hand) return
        this.handleHandMouseenter(
          { combo: hand, disabled: !hand.players[this.heroIndex].range },
          'force',
        )
      }
    },
    handleComboMousedown(hand) {
      this.handleHandMouseenter({ combo: hand, disabled: false }, 'force')
    },
    handleComboMouseenter(hand) {
      if (!hand) return
      this.handleHandMouseenter({ combo: hand, disabled: false })
    },
    getMouseoverId(e) {
      const el = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY)
      return el?.attributes?.id?.value
    },
    handleHandClick({ combo, disabled }) {
      this.handleHandMouseenter({ combo, disabled, caller: 'click' }, 'force')
    },
    handleHandMouseenter({ combo, disabled, caller }, force = '') {
      if (disabled) return
      if (!force && !this.mousedownTimestamp) return

      const combos = this.rab_tableGroups.find(g => g.id === combo.group_id)
      const hands =
        this.builderMode === 'mode_nodelock'
          ? combos.combos.filter(cc => cc.isometric_bucket === combo.isometric_bucket)
          : [combo]

      this.handleCombosMouseenter({ combos, disabled: false, combos_hands: hands, caller }, force)
    },
    applySnapshot({ snapshot, fromTo = 'to' }) {
      const combos = this.rab_tableGroups[snapshot.combos_table_index]
      combos.combos = combos.combos.map((h, hIdx) => {
        h.is_locked = snapshot[fromTo].locks_hands[hIdx]
        h.solution = h.solution.map((s, sIdx) => {
          s.strategy = snapshot[fromTo].stra_hands[hIdx][sIdx]
          return s
        })
        return h
      })
      combos.is_locked = snapshot[fromTo].lock_combos
      combos.solution = combos.solution.map((s, sIdx) => ({
        ...s,
        strategy: snapshot[fromTo].stra_combos[sIdx],
      }))
    },
    go(num) {
      if (num === -1) {
        if (!this.snapshots_to[0]) return
        const mousedownTimestamp = this.snapshots_to[0].timestamp
        const items = this.snapshots_to.filter(i => i.timestamp === mousedownTimestamp)
        items.forEach(i => this.applySnapshot({ snapshot: i, fromTo: 'from' }))

        this.snapshots_to = this.snapshots_to.filter(i => i.timestamp !== mousedownTimestamp)
        this.snapshots_from = [...items, ...this.snapshots_from]
      } else {
        if (!this.snapshots_from[0]) return
        const mousedownTimestamp = this.snapshots_from[0].timestamp
        const items = this.snapshots_from.filter(i => i.timestamp === mousedownTimestamp)
        items.forEach((i, idx) =>
          this.applySnapshot({ snapshot: items[items.length - 1 - idx], fromTo: 'to' }),
        )

        this.snapshots_from = this.snapshots_from.filter(i => i.timestamp !== mousedownTimestamp)
        this.snapshots_to = [...items, ...this.snapshots_to]
      }

      this.getRabSolutionPicked()
      this.getRabCategoriesSolution()
    },
    handleBtnModeClick(str) {
      // painter, locker
      this.btnMode = str
      this.lockMode = str === 'locker' ? 'action-unset' : 'disabled'
    },
    handlePaintModeClick(str) {
      this.paintMode = str
      this.getCursorStyle()
    },
    resetLocks(bool = false) {
      this.rab_tableGroups = this.rab_tableGroups.map(gg => ({
        ...gg,
        is_locked: gg.players[this.heroIndex].default.range ? bool : false,
        combos: gg.combos.map(cc => ({
          ...cc,
          is_locked: cc.players[this.heroIndex].default.range ? bool : false,
        })),
      }))
      this.$store.dispatch(SNK('sol_detail_initialize', this.namespace), {
        tableGroups: this.rab_tableGroups,
      })
      this.getRabCategoriesSolution() // reset locks here
      this.emitUpdate()
    },
    handleActionUpdate(actions) {
      this.rab_solution_paint = actions
      this.getCursorStyle()
    },
    getCursorStyle() {
      this.rab_svgCursor = getSvgCursor({
        solution: this.rab_solution_paint,
        useHex: this.useHex,
        paintMode: this.paintMode,
      })
    },
    getRabSolutionPicked() {
      const groups = this.rab_tableGroups.filter(i => i.players[this.heroIndex].range)
      let l_combos = groups.reduce((a, b) => [...a, ...b.combos], [])
      l_combos = l_combos.filter(i => i.players[this.heroIndex].range)
      const res = getCombosSolution({ combos: l_combos, solution: this.solution_picked })
      this.rab_solution_picked = res
    },
    getRabCategoriesSolution() {
      let rabCats = [
        this.solStatic.catDraws.filter(i => i.players[this.heroIndex].total_occurrence),
        this.solStatic.catHands.filter(i => i.players[this.heroIndex].total_occurrence),
        this.solStatic.catEqBuckets.filter(i => i.players[this.heroIndex].total_occurrence),
        this.solStatic.catEqBucketsAdvanced.filter(i => i.players[this.heroIndex].total_occurrence),
      ]
      rabCats = rabCats.map(cats =>
        cats.map(cat => {
          const groups = this.rab_tableGroups.filter(
            i =>
              i.players[this.heroIndex].default.range &&
              cat.players[this.heroIndex].groups.includes(i.id),
          )
          const l_combos = groups
            .reduce((acc, i) => [...acc, ...i.combos], [])
            .filter(
              i =>
                i.players[this.heroIndex].default.range &&
                cat.players[this.heroIndex].combos.includes(i.id),
            )
          let l_solution = getCombosSolution({
            combos: l_combos,
            solution: this.rab_solution_picked,
          })
          const isLocked = l_combos.some(i => i.is_locked)
          l_solution = l_solution.map(i => ({ ...i, total_frequency: i.strategy }))
          const updatedPlayer = { ...cat.players[this.heroIndex], solution: l_solution }
          return {
            ...cat,
            is_locked: isLocked,
            players: [updatedPlayer, ...cat.players.slice(1)],
          }
        }),
      )

      // console.log('rabCats', rabCats)
      this.rab_catDraws = rabCats[0]
      this.rab_catHands = rabCats[1]
      this.rab_catEqBuckets = rabCats[2]
      this.rab_catEqBucketsAdvanced = rabCats[3]
    },
    getCombosScore({ answer_combos }) {
      let totalScore = 0
      let totalStrategy = 0
      const l_combos = answer_combos.map((cc, cIdx) => {
        const score_solution = cc.corr_solution.map((ss, sIdx) => {
          const relScore = getRelativeSimilarity({
            refNum: ss.strategy,
            newNum: cc.rab_solution[sIdx].strategy,
          })
          // multiply by correct strategy to negate the effect of bad asnwers on combos with low strategy
          const score = relScore * ss.strategy

          totalScore += score
          totalStrategy += ss.strategy
          const r = {
            // ...ss,
            code: ss.code,
            score,
          }
          return r
        })

        const l_totalStrategy = cc.solution.reduce((acc, ss) => acc + ss.strategy, 0)
        const l_totalScore = score_solution.reduce((acc, ss) => acc + ss.score, 0)
        let l_score = l_totalScore / (l_totalStrategy || 1)
        l_score = l_score > 1 ? 0 : l_score < 0 ? 0 : l_score
        return {
          ...cc,
          score_solution,
          score: l_score,
          scoreGroup: getScoreGroup(l_score),
        }
      })

      let score = totalScore / (totalStrategy || 1)
      score = score > 1 ? 0 : score < 0 ? 0 : score

      const res = {
        combos: l_combos,
        totalCombos: l_combos.length,
        scoreGroup: getScoreGroup(score),
        score,
      }
      return res
    },
    handleConfirmClick() {
      if (this.builderMode === 'mode_nodelock') {
        this.$emit('click:confirm')
      } else {
        this.evaluate()
      }
    },
    evaluate() {
      if (!this.rab_tableGroups.length) return
      this.$store.dispatch(SNK('sol_filters_reset', this.namespace))
      this.$store.dispatch(SNK('sol_data_applyFilter', this.namespace))
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'group_id',
        value: '',
        player: '0',
      })
      this.getResults()
    },
    addScoreToCategories({ corr_categories, rab_categories, combos }) {
      const res = corr_categories.map((cat, cIdx) => {
        const l_combos = combos.filter(cc => cat.players[this.heroIndex].combos.includes(cc.id))
        const correct = cat.players[this.heroIndex].solution
        const answered = rab_categories[cIdx].players[this.heroIndex].solution
        const l_solution_picked = {
          correct:
            this.grouping === 'swv_grouping_none'
              ? correct
              : getGroupedActions({
                  actions: correct,
                  grouping: this.grouping,
                  groupValues: ['total_frequency'],
                }),
          answered:
            this.grouping === 'swv_grouping_none'
              ? answered
              : getGroupedActions({
                  actions: answered,
                  grouping: this.grouping,
                  groupValues: ['strategy'],
                }),
        }
        const r = {
          ...cat,
          total: this.getCombosScore({ answer_combos: l_combos }),
          solution_picked: l_solution_picked,
        }
        return r
      })
      return res
    },
    getResults() {
      this.resetLocks()

      const corr_combos = this.solDynamic.tableGroups.reduce(
        (acc, group) => [
          ...acc,
          ...group.combos.filter(i => i.players[this.heroIndex].default.range),
        ],
        [],
      )
      const rab_combos = this.rab_tableGroups.reduce(
        (acc, group) => [
          ...acc,
          ...group.combos.filter(i => i.players[this.heroIndex].default.range),
        ],
        [],
      )

      let solution_picked = {
        correct: this.solution_picked,
        answered: this.rab_solution_picked,
      }

      let answer_combos = []
      if (this.grouping !== 'swv_grouping_none') {
        solution_picked = {
          correct: getGroupedActions({
            actions: solution_picked.correct,
            grouping: this.grouping,
            groupValues: ['total_frequency'],
          }),
          answered: getGroupedActions({
            actions: solution_picked.answered,
            grouping: this.grouping,
            groupValues: ['strategy'],
          }),
        }

        answer_combos = corr_combos.map((cc, cIdx) => ({
          ...cc,
          rab_idx: cIdx,
          corr_solution: getGroupedActions({
            actions: cc.solution,
            grouping: this.grouping,
            groupValues: ['strategy'],
          }),
          rab_solution: getGroupedActions({
            actions: rab_combos[cIdx].solution,
            grouping: this.grouping,
            groupValues: ['strategy'],
          }),
        }))
      } else {
        answer_combos = corr_combos.map((cc, cIdx) => ({
          ...cc,
          rab_idx: cIdx,
          corr_solution: cc.solution,
          rab_solution: rab_combos[cIdx].solution,
        }))
      }

      const { combos, score, scoreGroup } = this.getCombosScore({ answer_combos })
      let scoreGroups = getScoreGroups().map(sc => {
        // maybe optimize this lookup
        let l_combos = combos.filter(cc => cc.scoreGroup.id === sc.id)
        l_combos = l_combos.map(cc => rab_combos.find(c => c.id === cc.id))
        const l_corr_combos = l_combos.map(cc => corr_combos.find(c => c.id === cc.id))
        const correct = getCombosSolution({ combos: l_corr_combos, solution: this.solution_picked })
        const answered = getCombosSolution({ combos: l_combos, solution: this.solution_picked })
        const l_solution_picked = {
          correct:
            this.grouping === 'swv_grouping_none'
              ? correct
              : getGroupedActions({
                  actions: correct,
                  grouping: this.grouping,
                  groupValues: ['strategy'],
                }),
          answered:
            this.grouping === 'swv_grouping_none'
              ? answered
              : getGroupedActions({
                  actions: answered,
                  grouping: this.grouping,
                  groupValues: ['strategy'],
                }),
        }
        // console.log(l_solution_picked, l_corr_combos.filter(i => i.hero.range))
        // debugger
        return {
          ...sc,
          solution_picked: l_solution_picked,
          combos: l_combos,
          totalCombos: l_combos.length,
        }
      })
      scoreGroups = scoreGroups.filter(sc => sc.totalCombos)

      const hands = this.addScoreToCategories({
        corr_categories: this.solStatic.catHands.filter(
          i => i.players[this.heroIndex].total_occurrence,
        ),
        rab_categories: this.rab_catHands,
        combos,
      })
      const draws = this.addScoreToCategories({
        corr_categories: this.solStatic.catDraws.filter(
          i => i.players[this.heroIndex].total_occurrence,
        ),
        rab_categories: this.rab_catDraws,
        combos,
      })
      const eqBuckets = this.addScoreToCategories({
        corr_categories: this.solStatic.catEqBuckets.filter(
          i => i.players[this.heroIndex].total_occurrence,
        ),
        rab_categories: this.rab_catEqBuckets,
        combos,
      })
      const eqBucketsAdvanced = this.addScoreToCategories({
        corr_categories: this.solStatic.catEqBucketsAdvanced.filter(
          i => i.players[this.heroIndex].total_occurrence,
        ),
        rab_categories: this.rab_catEqBucketsAdvanced,
        combos,
      })

      let allCats = [...hands, ...draws, ...eqBuckets, ...eqBucketsAdvanced]

      allCats = allCats.sort((a, b) => b.total.score - a.total.score)
      const bestCats = allCats.slice(0, 3)
      const worstCats = allCats.slice(-3)

      const res = {
        total: {
          combos,
          score,
          scoreGroup,
        },
        scoreGroups,
        hands,
        draws,
        eqBuckets,
        eqBucketsAdvanced,
        bestCats,
        worstCats,
        solution_picked,
      }
      this.rab_result = res
    },
    initialize({ tableGroups = this.solDynamic.tableGroups, lockValue = undefined } = {}) {
      const solution = this.solution_picked
      this.rab_solution_paint = this.defaultToCheckFold
        ? getEqualSolution({ solution })
        : this.solution_picked.map(a => ({
            ...a,
            strategy: a.strategy || a.total_frequency,
          }))

      if (this.defaultToCheckFold) {
        // rangeBuilder
        const checkFold = solution.some(a => a.code === 'X') ? 'X' : 'F'
        const combosSolution = solution.map(i => ({
          ...i,
          strategy: i.code === checkFold ? 1 : 0,
        }))

        this.rab_tableGroups = tableGroups.map(gg => ({
          ...gg,
          is_locked: false,
          solution: combosSolution,
          default: {
            solution: gg.solution,
          },
          combos: gg.combos.map(cc => ({
            ...cc,
            is_locked: false,
            solution: combosSolution,
            default: {
              solution: cc.solution,
            },
          })),
        }))
      } else {
        // rangeBuilder
        this.rab_tableGroups = tableGroups.map(gg => ({
          ...gg,
          is_locked: lockValue ?? gg.is_locked ?? false,
          solution: gg.solution,
          default: {
            // solution: gg.default?.solution || gg.solution,
            solution: gg.solution,
          },
          combos: gg.combos.map(cc => ({
            ...cc,
            is_locked: lockValue ?? cc.is_locked ?? false,
            solution: cc.solution,
            default: {
              // solution: cc.default?.solution || cc.solution,
              solution: cc.solution,
            },
          })),
        }))
      }

      this.getRabSolutionPicked()
      this.getRabCategoriesSolution()

      this.$store.dispatch(SNK('sol_detail_initialize', this.namespace), {
        tableGroups: this.rab_tableGroups,
      })
      this.getCursorStyle()

      this.mousedownTimestamp = 0
      this.snapshots_from = []
      this.snapshots_to = []

      this.rab_result = null
      this.emitUpdate()
    },
    nodelock_slidersRepaint({ tableGroups, lockValue = undefined, keepLocks }) {
      // lockValue = undefined result to keeping a lock
      this.rab_tableGroups = tableGroups.map((gg, ggIdx) => ({
        ...gg,
        is_locked: lockValue ?? this.rab_tableGroups[ggIdx].is_locked,
        solution: gg.solution,
        default: {
          solution: this.rab_tableGroups[ggIdx].default.solution,
        },
        combos: gg.combos.map((cc, ccIdx) => ({
          ...cc,
          is_locked: lockValue ?? this.rab_tableGroups[ggIdx].combos[ccIdx].is_locked,
          solution: cc.solution,
          default: {
            solution: this.rab_tableGroups[ggIdx].combos[ccIdx].default.solution,
          },
        })),
      }))

      this.getRabSolutionPicked()
      this.getRabCategoriesSolution()

      this.$store.dispatch(SNK('sol_detail_initialize', this.namespace), {
        tableGroups: this.rab_tableGroups,
      })
      this.getCursorStyle()

      // this.mousedownTimestamp = 0
      // this.snapshots_from = []
      // this.snapshots_to = []

      this.emitUpdate()
    },
    resetState() {
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'group',
        value: null,
        player: '0',
      })
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'group_id',
        value: '',
        player: '0',
      })

      this.rab_solution_paint = []
      this.rab_svgCursor = { '--rab-cursor': 'default' }
      this.rab_solution_picked = []
      this.rab_tableGroups = []
      this.rab_catDraws = []
      this.rab_catHands = []
      this.rab_catEqBuckets = []
      this.rab_catEqBucketsAdvanced = []
      this.rab_result = null
      this.mousedownTimestamp = 0
      this.lockMode = 'disabled'
      this.snapshots_from = []
      this.snapshots_to = []
      this.$emit('reset')
    },
    repaintLocalGroups() {
      this.$store.dispatch('globals_action', '')
      this.rab_tableGroups = this.rab_tableGroups.map(i => ({
        ...i,
        solution: getActionStyles({ available_actions: i.solution }),
        combos: i.combos.map(j => ({
          ...j,
          solution: getActionStyles({ available_actions: j.solution }),
        })),
      }))

      this.rab_solution_picked = getActionStyles({
        available_actions: this.rab_solution_picked,
      })
      this.rab_solution_paint = getActionStyles({
        available_actions: this.rab_solution_paint,
      })

      if (this.rab_result) {
        this.evaluate()
      }
    },
  },
  computed: {
    isPreflop() {
      return this.solStreet === 'preflop'
    },
    showFlopContent() {
      return this.solElite?.is_using || this.solStreet !== 'preflop'
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
    isFinished() {
      return !!this.rab_result
    },
    backDisabled() {
      return !this.snapshots_to[0]
    },
    forwardDisabled() {
      return !this.snapshots_from[0]
    },
  },
  watch: {
    filterCombos() {
      // remap ranges
      if (!this.rab_tableGroups.length) return
      this.rab_tableGroups = this.solDynamic.tableGroups.map((gg, ggIdx) => {
        const rab_gg = this.rab_tableGroups[ggIdx]
        rab_gg.players[this.heroIndex].range = gg.players[this.heroIndex].range
        rab_gg.players[this.heroIndex].range_normalized =
          gg.players[this.heroIndex].range_normalized
        rab_gg.players[this.heroIndex].range_full_height =
          gg.players[this.heroIndex].range_full_height
        rab_gg.combos = gg.combos.map((cc, ccIdx) => {
          const rab_cc = rab_gg.combos[ccIdx]
          rab_cc.players[this.heroIndex].range = cc.players[this.heroIndex].range
          rab_cc.players[this.heroIndex].range_normalized =
            cc.players[this.heroIndex].range_normalized
          rab_cc.players[this.heroIndex].range_full_height =
            cc.players[this.heroIndex].range_full_height
          return rab_cc
        })
        const combosInRange = rab_gg.combos.filter(cc => cc.players[this.heroIndex].range)
        rab_gg.solution = getCombosSolution({
          combos: combosInRange,
          solution: this.solution_picked,
        })
        return rab_gg
      })
      this.getRabSolutionPicked()
    },
    grouping() {
      this.nodelockLockedActions = [] // reset this on every grouping change as it would otherwise be unmanageable to track what action is locked in what grouping
      this.getCursorStyle()
      if (this.rab_result) {
        this.getResults()
      }
    },
    hotkeysPressed(keys) {
      if (!keys) return
      const goBack = {
        fn: () => {
          this.go(-1)
        },
      }
      const goForward = {
        fn: () => {
          this.go(1)
        },
      }
      const hotkeyActions = {
        goHistoryBack1: {
          keys: ['command', 'z'],
          ...goBack,
        },
        goHistoryBack2: {
          keys: ['control', 'z'],
          ...goBack,
        },
        goHistoryFw1: {
          keys: ['control', 'y'],
          ...goForward,
        },
        goHistoryFw2: {
          keys: ['command', 'y'],
          ...goForward,
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
    globals_action(action) {
      if (action === 'rangeBuilder_repaint') {
        this.repaintLocalGroups()
      } else if (action === 'nodelock_lockallconfirmnodelock') {
        this.resetLocks(true)
        this.handleConfirmClick()
      } else if (action === 'nodelock_confirmnodelock') {
        this.handleConfirmClick()
      }
    },
  },
}
</script>
<style lang="scss">
.rabbuildr {
  --rab-cursor-locked: not-allowed;
  --rab-cursor-paint-disabled: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' style='transform:scaleY(-1)' width='32' height='32'><defs><clipPath id='clipPath0'><path d='M4,24 h24 a4,4 0 0 1 4,4 v0 a4,4 0 0 1 -4,4 h-24 a4,4 0 0 1 -4,-4 v0 a4,4 0 0 1 4,-4'/></clipPath></defs><path fill='%237f7f7f' style='transform:scale(1.125)' d='M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21A4,4 0 0,0 10,17A3,3 0 0,0 7,14Z' /><g style='clip-path: url(%23clipPath0)'><path d='M0,24 h32 v8 h-32 v-8 z' stroke-width='0' style='fill: %237f7f7f' /></g></svg>"),
    auto;
  &_mode_nodelock {
    --rab-cursor-locked: var(--rab-cursor);
    .rtc_icon-lock,
    .htc_icon-lock {
      pointer-events: none;
    }
    .rtc_folded,
    .htc_empty {
      --rab-cursor: var(--rab-cursor-paint-disabled) !important;
      // cursor: default !important;
      pointer-events: auto !important;
    }
  }
  &:not(.rabbuildr_finished) {
    --rab-cursor: default;
    --rab-cursor-lock: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><path fill='white' d='M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z' /></svg>"),
      auto;
    --rab-cursor-unlock: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><path fill='white' d='M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17Z' /></svg>"),
      auto;
    // --rab-cursor-unlock: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><path fill='white' d='M18 1C15.24 1 13 3.24 13 6V8H4C2.9 8 2 8.89 2 10V20C2 21.11 2.9 22 4 22H16C17.11 22 18 21.11 18 20V10C18 8.9 17.11 8 16 8H15V6C15 4.34 16.34 3 18 3C19.66 3 21 4.34 21 6V8H23V6C23 3.24 20.76 1 18 1M10 13C11.1 13 12 13.89 12 15C12 16.11 11.11 17 10 17C8.9 17 8 16.11 8 15C8 13.9 8.9 13 10 13Z' /></svg>"),
    //   auto;

    .rtc,
    .htc,
    .combosrowhero,
    .range-category-filter-item {
      cursor: var(--rab-cursor) !important;
    }
    .rtc_locked,
    .htc_locked,
    .combosrowhero_locked {
      --rab-cursor: var(--rab-cursor-locked);
    }

    .combosrowhero {
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      user-select: none;
    }

    .rtc_folded,
    .htc_empty {
      --rab-cursor: var(--rab-cursor-paint-disabled) !important;
      // cursor: default !important;
      pointer-events: auto !important;
    }
  }
  &_lock-mode {
    .rtc {
      --rab-cursor: var(--rab-cursor-lock) !important;
      .rtc_title {
        cursor: pointer !important;
      }
    }
    .rtc_locked {
      --rab-cursor: var(--rab-cursor-unlock) !important;
    }
    .htc {
      --rab-cursor: var(--rab-cursor-lock) !important;
      cursor: var(--rab-cursor) !important;
    }
    .htc_locked {
      --rab-cursor: var(--rab-cursor-unlock) !important;
      cursor: var(--rab-cursor) !important;
    }
    .combosrowhero {
      --rab-cursor: var(--rab-cursor-lock) !important;
      cursor: var(--rab-cursor) !important;
      .combosrowhero_strategy {
        pointer-events: none;
      }
    }
    .range-category-filter-item {
      --rab-cursor: var(--rab-cursor-lock) !important;
    }

    .combosrowhero_locked {
      --rab-cursor: var(--rab-cursor-unlock) !important;
    }
    .range-category-filter-item_locked {
      --rab-cursor: var(--rab-cursor-unlock) !important;
    }

    &_action-lock {
      .rtc,
      .htc,
      .combosrowhero,
      .range-category-filter-item {
        --rab-cursor: var(--rab-cursor-lock) !important;
      }
    }
    &_action-unlock {
      .rtc,
      .htc,
      .combosrowhero,
      .range-category-filter-item {
        --rab-cursor: var(--rab-cursor-unlock) !important;
      }
    }
  }
}

@media (hover: hover) and (pointer: fine) {
  .rabbuildr {
    .rtc_active {
      .rtc_title {
        cursor: pointer !important;
        &::after {
          content: '';
          position: absolute;
          width: calc(100% + 0.25rem);
          height: calc(100% - 0.25rem);
          left: -0.125rem;
          top: 0.125rem;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 4px;
          opacity: 0.5;
        }
      }
    }
    &:not(.rabbuildr_finished) {
      .rtc:not(.rtc_folded) {
        &:hover {
          .rtc_title {
            cursor: pointer !important;
            &::after {
              content: '';
              position: absolute;
              width: calc(100% + 0.25rem);
              height: calc(100% - 0.25rem);
              left: -0.125rem;
              top: 0.125rem;
              background: rgba(255, 255, 255, 0.5);
              border-radius: 4px;
              opacity: 0.5;
            }
            &:hover {
              &::after {
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }
}
</style>
